const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";

export const ENABLE_POPUNDER = false;
export const ENABLE_PUSH_NOTIFICATION = false;
export const ENABLE_IN_PAGE_PUSH = false;
export const ENABLE_VIGNETTE = false;

export const MONETAG_STORAGE_KEYS = {
  vignetteLastShown: "monetag_vignette_last_shown",
  inPageSessionLoaded: "monetag_inpage_session_loaded",
  pushLastShown: "monetag_push_last_shown",
  onclickLastShown: "monetag_onclick_last_shown",
  loadedZones: "monetag_loaded_zones",
  vignetteRotation: "monetag_vignette_rotation_index",
  inPageRotation: "monetag_inpage_rotation_index",
  pushRotation: "monetag_push_rotation_index",
  popunderRotation: "monetag_popunder_rotation_index"
};

export const MONETAG_LIMITS = {
  vignetteCapMs: 24 * 60 * 60 * 1000,
  pushCapMs: 24 * 60 * 60 * 1000,
  popunderCapMs: 24 * 60 * 60 * 1000,
  globalDelayMinMs: 4000,
  globalDelayMaxMs: 5000,
  pushExtraDelayMs: 12000,
  mobileMaxGlobalTags: 1,
  desktopMaxGlobalTags: 3
};

export const MONETAG_ADS = {
  vignette: [
    { zoneId: "11258329", zone: "11258329", src: "https://n6wxm.com/vignette.min.js", label: "Vignette Banner 11258329" },
    { zoneId: "11258325", zone: "11258325", src: "https://n6wxm.com/vignette.min.js", label: "Vignette Banner 11258325" },
    { zoneId: "11248782", zone: "11248782", src: "https://n6wxm.com/vignette.min.js", label: "Vignette Banner 11248782" }
  ],
  inPagePush: [
    { zoneId: "11258328", zone: "11258328", src: "https://nap5k.com/tag.min.js", label: "In-Page Push 11258328" },
    { zoneId: "11258326", zone: "11258326", src: "https://nap5k.com/tag.min.js", label: "In-Page Push 11258326" },
    { zoneId: "11248781", zone: "11248781", src: "https://nap5k.com/tag.min.js", label: "In-Page Push 11248781" }
  ],
  pushNotification: [
    { zoneId: "11248779", zone: "11248779", src: "https://5gvci.com/act/files/tag.min.js?z=11248779", label: "Push Notification 11248779", enabled: ENABLE_PUSH_NOTIFICATION }
  ],
  popunder: [
    { zoneId: "11248769", zone: "11248769", src: "https://al5sm.com/tag.min.js", label: "OnClick / Popunder 11248769", enabled: ENABLE_POPUNDER }
  ],
  directLinks: [
    { id: "11258324", href: "https://omg10.com/4/11258324", label: "Direct Link 11258324", autoOpen: false },
    { id: "11248790", href: "https://omg10.com/4/11248790", label: "Direct Link 11248790", autoOpen: false }
  ]
};

export const MONETAG_ZONES = {
  vignetteBanner: MONETAG_ADS.vignette,
  inPagePush: MONETAG_ADS.inPagePush,
  pushNotification: MONETAG_ADS.pushNotification,
  popunder: MONETAG_ADS.popunder
};

const ALL_ALLOWED_ZONES = new Set(
  Object.values(MONETAG_ZONES).flat().map((zone) => zone.zoneId)
);

const ALLOWED_SCRIPT_SOURCES = [
  /^https:\/\/n6wxm\.com\/vignette\.min\.js$/i,
  /^https:\/\/nap5k\.com\/tag\.min\.js$/i,
  /^https:\/\/5gvci\.com\/act\/files\/tag\.min\.js\?z=11248779$/i,
  /^https:\/\/al5sm\.com\/tag\.min\.js$/i
];

const DENIED_EXACT_ROUTES = [
  "/privacy",
  "/privacy-policy",
  "/terms",
  "/terms-of-use",
  "/cookie-policy",
  "/cookies",
  "/contact",
  "/partnerships",
  "/advertise",
  "/editorial-policy",
  "/about-techniahq",
  "/login",
  "/admin",
  "/dashboard",
  "/account",
  "/profile",
  "/settings",
  "/manager",
  "/private"
];

const DENIED_ROUTE_PREFIXES = [
  "/admin",
  "/dashboard",
  "/account",
  "/profile",
  "/settings",
  "/manager",
  "/private",
  "/login",
  "/register",
  "/checkout"
];

const HIGH_VALUE_ARTICLE_PREFIXES = [
  "/ai/",
  "/ai-news/",
  "/robotics/"
];

const pendingMonetagScripts = new Map();

function storageGet(storage, key, fallback = null) {
  if (!isBrowser || !storage) return fallback;
  try {
    const value = storage.getItem(key);
    return value === null ? fallback : value;
  } catch (_) {
    return fallback;
  }
}

function storageSet(storage, key, value) {
  if (!isBrowser || !storage) return;
  try {
    storage.setItem(key, String(value));
  } catch (_) {
    // Private browsing or strict tracking prevention can block storage.
  }
}

function readJson(storage, key, fallback = []) {
  const raw = storageGet(storage, key, null);
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch (_) {
    return fallback;
  }
}

function writeJson(storage, key, value) {
  storageSet(storage, key, JSON.stringify(value));
}

function isScriptSourceAllowed(src) {
  return Boolean(src && ALLOWED_SCRIPT_SOURCES.some((pattern) => pattern.test(src)));
}

export function normalizeMonetagRoute(pathname = "/") {
  const clean = String(pathname || "/").split("?")[0].split("#")[0].replace(/\/+$/g, "");
  return clean || "/";
}

export function isMonetagRouteDenied(pathname = "/") {
  const route = normalizeMonetagRoute(pathname);
  return DENIED_EXACT_ROUTES.includes(route) || DENIED_ROUTE_PREFIXES.some((prefix) => route === prefix || route.startsWith(`${prefix}/`));
}

export function isHighValueArticleRoute(pathname = "/") {
  const route = normalizeMonetagRoute(pathname);
  return HIGH_VALUE_ARTICLE_PREFIXES.some((prefix) => route.startsWith(prefix) && route.split("/").filter(Boolean).length >= 2);
}

export function isMonetagRuntimeAllowed(pathname = "/") {
  if (!isBrowser) return false;
  if (process.env.REACT_APP_ADS_ENABLED === "false") return false;
  if (process.env.NODE_ENV !== "production") return false;
  const { hostname, protocol, search } = window.location;
  if (protocol !== "https:" && protocol !== "http:") return false;
  if (/^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(hostname)) return false;
  if (/[?&](preview|ads)=(1|true|off|false)/i.test(search)) return false;
  if (isMonetagRouteDenied(pathname)) return false;
  return true;
}

export function getLoadedMonetagZones() {
  if (!isBrowser) return [];
  const globalZones = Array.isArray(window.__MONETAG_LOADED_ZONES__) ? window.__MONETAG_LOADED_ZONES__ : [];
  const storedZones = readJson(window.sessionStorage, MONETAG_STORAGE_KEYS.loadedZones, []);
  const merged = Array.from(new Set([...globalZones, ...storedZones].map(String)));
  window.__MONETAG_LOADED_ZONES__ = merged;
  writeJson(window.sessionStorage, MONETAG_STORAGE_KEYS.loadedZones, merged);
  return merged;
}

export function markMonetagZoneLoaded(zoneId) {
  if (!isBrowser || !zoneId) return;
  const loaded = new Set(getLoadedMonetagZones());
  loaded.add(String(zoneId));
  const zones = Array.from(loaded);
  window.__MONETAG_LOADED_ZONES__ = zones;
  writeJson(window.sessionStorage, MONETAG_STORAGE_KEYS.loadedZones, zones);
}

function zoneAlreadyInjected(zoneId) {
  if (!isBrowser || !zoneId) return true;
  const safeZoneId = String(zoneId).replace(/"/g, "");
  return Boolean(
    document.querySelector(`script[data-zone="${safeZoneId}"]`) ||
    document.getElementById(`monetag-${safeZoneId}`) ||
    getLoadedMonetagZones().includes(safeZoneId)
  );
}

function isMobileDevice() {
  if (!isBrowser || typeof navigator === "undefined") return false;
  const coarsePointer = typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;
  return coarsePointer || /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");
}

function rotationKeyFor(format) {
  if (format === "vignetteBanner") return MONETAG_STORAGE_KEYS.vignetteRotation;
  if (format === "inPagePush") return MONETAG_STORAGE_KEYS.inPageRotation;
  if (format === "pushNotification") return MONETAG_STORAGE_KEYS.pushRotation;
  if (format === "popunder") return MONETAG_STORAGE_KEYS.popunderRotation;
  return `${format}_rotation_index`;
}

function getZonesForFormat(format) {
  return MONETAG_ZONES[format] || [];
}

function getNextZone(format) {
  if (!isBrowser) return null;
  const zones = getZonesForFormat(format).filter((zone) => zone.enabled !== false);
  if (!zones.length) return null;
  const rotationKey = rotationKeyFor(format);
  const current = Number(storageGet(window.localStorage, rotationKey, 0)) || 0;
  const zone = zones[current % zones.length];
  storageSet(window.localStorage, rotationKey, current + 1);
  return zone;
}

function capPassed(localStorageKey, capMs) {
  if (!isBrowser) return false;
  const lastShownAt = Number(storageGet(window.localStorage, localStorageKey, 0)) || 0;
  return Date.now() - lastShownAt > capMs;
}

export function canLoadMonetagVignette(pathname = "/") {
  if (!ENABLE_VIGNETTE || !isMonetagRuntimeAllowed(pathname)) return false;
  return capPassed(MONETAG_STORAGE_KEYS.vignetteLastShown, MONETAG_LIMITS.vignetteCapMs);
}

export function canLoadMonetagInPage(pathname = "/") {
  if (!ENABLE_IN_PAGE_PUSH || !isMonetagRuntimeAllowed(pathname)) return false;
  return storageGet(window.sessionStorage, MONETAG_STORAGE_KEYS.inPageSessionLoaded, "0") !== "1";
}

export function canLoadMonetagPushNotification(pathname = "/") {
  if (!ENABLE_PUSH_NOTIFICATION || !isMonetagRuntimeAllowed(pathname)) return false;
  return capPassed(MONETAG_STORAGE_KEYS.pushLastShown, MONETAG_LIMITS.pushCapMs);
}

export function canLoadMonetagPopunder(pathname = "/") {
  if (!ENABLE_POPUNDER || !isMonetagRuntimeAllowed(pathname)) return false;
  if (isMobileDevice()) return false;
  if (isHighValueArticleRoute(pathname)) return false;
  return capPassed(MONETAG_STORAGE_KEYS.onclickLastShown, MONETAG_LIMITS.popunderCapMs);
}

function markFrequency(format) {
  if (!isBrowser) return;
  if (format === "vignetteBanner") {
    storageSet(window.localStorage, MONETAG_STORAGE_KEYS.vignetteLastShown, Date.now());
  }
  if (format === "inPagePush") {
    storageSet(window.sessionStorage, MONETAG_STORAGE_KEYS.inPageSessionLoaded, "1");
  }
  if (format === "pushNotification") {
    storageSet(window.localStorage, MONETAG_STORAGE_KEYS.pushLastShown, Date.now());
  }
  if (format === "popunder") {
    storageSet(window.localStorage, MONETAG_STORAGE_KEYS.onclickLastShown, Date.now());
  }
}

export function safeLoadAd(zoneId, src, options = {}) {
  const format = options.format || "inPagePush";
  const route = options.route || "/";
  const placement = options.placement || "global";

  // Enforce format settings here as well as in the React placement layer.
  const formatEnabled = {
    inPagePush: ENABLE_IN_PAGE_PUSH,
    vignetteBanner: ENABLE_VIGNETTE,
    pushNotification: ENABLE_PUSH_NOTIFICATION,
    popunder: ENABLE_POPUNDER,
  };
  if (formatEnabled[format] === false) {
    return Promise.resolve({ skipped: true, reason: "format-disabled", zoneId, format });
  }

  if (!isMonetagRuntimeAllowed(route)) {
    return Promise.resolve({ skipped: true, reason: "runtime-disabled", zoneId, format });
  }

  const normalizedZoneId = String(zoneId || "");
  if (!ALL_ALLOWED_ZONES.has(normalizedZoneId)) {
    return Promise.reject(new Error(`Monetag zone is not in the approved TechniaHQRobot zone list: ${normalizedZoneId}`));
  }

  if (!isScriptSourceAllowed(src)) {
    return Promise.reject(new Error(`Unsupported Monetag script source for zone ${normalizedZoneId}`));
  }

  const zoneConfig = getZonesForFormat(format).find((zone) => zone.zoneId === normalizedZoneId);
  if (zoneConfig?.enabled === false) {
    return Promise.resolve({ skipped: true, reason: "format-disabled", zoneId: normalizedZoneId, format });
  }

  if (format === "popunder" && !canLoadMonetagPopunder(route)) {
    return Promise.resolve({ skipped: true, reason: "popunder-disabled-or-capped", zoneId: normalizedZoneId, format });
  }

  if (zoneAlreadyInjected(normalizedZoneId)) {
    return Promise.resolve({ skipped: true, reason: "already-loaded", zoneId: normalizedZoneId, format });
  }

  if (pendingMonetagScripts.has(normalizedZoneId)) {
    return pendingMonetagScripts.get(normalizedZoneId);
  }

  const promise = new Promise((resolve, reject) => {
    const parent = document.body || document.documentElement;
    const script = document.createElement("script");
    script.id = `monetag-${normalizedZoneId}`;
    script.async = true;
    script.src = src;
    script.dataset.zone = normalizedZoneId;
    script.dataset.techniahqAd = "monetag";
    script.dataset.adFormat = format;
    script.dataset.adPlacement = placement;
    script.setAttribute("data-cfasync", "false");

    script.onload = () => {
      pendingMonetagScripts.delete(normalizedZoneId);
      markMonetagZoneLoaded(normalizedZoneId);
      markFrequency(format);
      resolve({ loaded: true, zoneId: normalizedZoneId, format, placement });
    };

    script.onerror = () => {
      pendingMonetagScripts.delete(normalizedZoneId);
      script.remove();
      reject(new Error(`Failed to load Monetag zone ${normalizedZoneId}`));
    };

    parent.appendChild(script);
  });

  pendingMonetagScripts.set(normalizedZoneId, promise);
  return promise;
}

export function safeLoadMonetagAd({ zoneId, src, format = "inPagePush", route = "/", placement = "global" }) {
  return safeLoadAd(zoneId, src, { format, route, placement });
}

export function requestMonetagInPagePush(route = "/", options = {}) {
  if (!canLoadMonetagInPage(route)) {
    return Promise.resolve({ skipped: true, reason: "in-page-frequency-cap", format: "inPagePush" });
  }
  const zone = getNextZone("inPagePush");
  if (!zone) return Promise.resolve({ skipped: true, reason: "no-in-page-zone", format: "inPagePush" });
  return safeLoadMonetagAd({ ...zone, format: "inPagePush", route, placement: options.placement || "global" });
}

export function requestMonetagVignetteBanner(route = "/", options = {}) {
  if (!canLoadMonetagVignette(route)) {
    return Promise.resolve({ skipped: true, reason: "vignette-frequency-cap", format: "vignetteBanner" });
  }
  const zone = getNextZone("vignetteBanner");
  if (!zone) return Promise.resolve({ skipped: true, reason: "no-vignette-zone", format: "vignetteBanner" });
  return safeLoadMonetagAd({ ...zone, format: "vignetteBanner", route, placement: options.placement || "global" });
}

export function requestMonetagPushNotification(route = "/", options = {}) {
  if (!canLoadMonetagPushNotification(route)) {
    return Promise.resolve({ skipped: true, reason: "push-frequency-cap", format: "pushNotification" });
  }
  const zone = getNextZone("pushNotification");
  if (!zone) return Promise.resolve({ skipped: true, reason: "no-push-zone", format: "pushNotification" });
  return safeLoadMonetagAd({ ...zone, format: "pushNotification", route, placement: options.placement || "global-delayed-push" });
}

export function requestMonetagPopunder(route = "/", options = {}) {
  if (!canLoadMonetagPopunder(route)) {
    return Promise.resolve({ skipped: true, reason: "popunder-disabled-or-capped", format: "popunder" });
  }
  const zone = getNextZone("popunder");
  if (!zone) return Promise.resolve({ skipped: true, reason: "no-popunder-zone", format: "popunder" });
  return safeLoadMonetagAd({ ...zone, format: "popunder", route, placement: options.placement || "disabled-popunder" });
}

export function getMonetagDirectLinks() {
  return MONETAG_ADS.directLinks.map((item) => ({ ...item }));
}

export function getMonetagGlobalPlan(route = "/") {
  if (!isMonetagRuntimeAllowed(route)) return [];
  const plan = [];
  const mobile = isMobileDevice();
  const maxTags = mobile ? MONETAG_LIMITS.mobileMaxGlobalTags : MONETAG_LIMITS.desktopMaxGlobalTags;

  if (canLoadMonetagInPage(route)) {
    plan.push({ format: "inPagePush" });
  }

  if (plan.length < maxTags && canLoadMonetagVignette(route)) {
    plan.push({ format: "vignetteBanner" });
  }

  if (!mobile && plan.length < maxTags && canLoadMonetagPushNotification(route)) {
    plan.push({ format: "pushNotification", extraDelayMs: MONETAG_LIMITS.pushExtraDelayMs });
  }

  if (!mobile && plan.length < maxTags && canLoadMonetagPopunder(route)) {
    plan.push({ format: "popunder", extraDelayMs: MONETAG_LIMITS.pushExtraDelayMs });
  }

  return plan.slice(0, maxTags);
}

export function scheduleMonetagGlobalAds(route = "/") {
  if (!isMonetagRuntimeAllowed(route)) return () => {};
  const plan = getMonetagGlobalPlan(route);
  if (!plan.length) return () => {};

  const timers = [];
  const baseDelay = MONETAG_LIMITS.globalDelayMinMs + Math.floor(Math.random() * (MONETAG_LIMITS.globalDelayMaxMs - MONETAG_LIMITS.globalDelayMinMs + 1));

  const runItem = (item) => {
    if (item.format === "inPagePush") return requestMonetagInPagePush(route, { placement: "global-delayed" });
    if (item.format === "vignetteBanner") return requestMonetagVignetteBanner(route, { placement: "global-delayed" });
    if (item.format === "pushNotification") return requestMonetagPushNotification(route, { placement: "global-delayed" });
    if (item.format === "popunder") return requestMonetagPopunder(route, { placement: "disabled-popunder" });
    return Promise.resolve({ skipped: true });
  };

  const schedule = (item, index) => {
    const delay = baseDelay + (item.extraDelayMs || index * 650);
    const timer = window.setTimeout(() => {
      const execute = () => runItem(item).catch(() => Promise.resolve({ skipped: true }));
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(execute, { timeout: 2500 });
      } else {
        execute();
      }
    }, delay);
    timers.push(timer);
  };

  plan.forEach(schedule);
  return () => timers.forEach((timer) => window.clearTimeout(timer));
}

export function getMonetagAuditSnapshot() {
  return {
    zones: MONETAG_ZONES,
    ads: MONETAG_ADS,
    storageKeys: MONETAG_STORAGE_KEYS,
    limits: MONETAG_LIMITS,
    enablePopunder: ENABLE_POPUNDER,
    enablePushNotification: ENABLE_PUSH_NOTIFICATION
  };
}
